import { Layout } from 'antd'
import dayjs from 'dayjs'
import { FooterHidden } from './FooterHidden'

const { Footer: AntdFooter } = Layout

export const Footer = () => (
  <AntdFooter>
    <FooterHidden year={dayjs().year()} />
  </AntdFooter>
)
